import { TherapistStatsDto } from "../../../../api-client";
import { useEffect, useRef, useState } from 'react';
import useStore from "../../../../helpers/useStore";
import { BIContext } from "../../../../stores/BIDashboard/biDashboard.provider";
import { calculateAverageStats, calculateByLocationStats, calculateTotalStats, flattenTherapistStats, mapTherapistTableData } from "../../helpers/therapistStatsHelpers";
import { useDebounce } from "../../../Transactions/Insurance/Base/hooks/useDebounce";

interface TherapistTotalsData {
  totalTherapistCount: number, 
  totalValue: number,
  totalAuslastung: number,
  totalRxCount: number,
  totalGaps: number
  totalGapsInHours: number,
}

interface TherapistTableData {
  name: string,
  // lastName: string | undefined,
  // nickName: string | undefined,
  value: number, // Umsatz
  auslastung: number,
  revenueProductivityHour: number,
  revenueScheduledHour: number,
  gaps: number,
  gapsInHours: number,
  rxCount: number,
}

interface TherapistAverageData {
  locationId: string,
  aveValue: number,
  aveAuslastung: number,
  aveRevenueProductivityHour: number,
  aveRevenueScheduledHour: number,
  aveRxCount: number,
  aveGaps: number,
  aveGapsInHours: number,
}

interface TherapistData {
  locationId: string,
  totalTherapistCount: number,
  totalValue: number,
  totalAuslastung: number,
  totalRxCount: number,
  totalGaps: number,
  totalGapsInHours: number,
  table: TherapistTableData[],
  average: TherapistAverageData[],
}

interface FlatTherapistData {
  locationId: string,
  lastName: string | undefined,
  firstName: string | undefined,
  value: number,
  auslastung: number,
  revenueProductivityHour: number,
  revenueScheduledHour: number,
  rxCount: number,
  gaps: number,
  gapsInHours: number,
}

const useTherapistStats = (startDate: Date, endDate: Date) => {
  const BIStore = useStore(BIContext); 
  const { getTherapistStats } = BIStore; 

  // Debounce date changes
  const debounceStartDate = useDebounce(startDate, 300);
  const debounceEndDate = useDebounce(endDate, 300);

  const [therapistData, setTherapistData] = useState<TherapistData[]>([]);
  const [therapistTotalsData, setTherapistTotalsData] = useState<TherapistTotalsData[]>([]);
  const [flatTherapistData, setFlatTherapistData] = useState<FlatTherapistData[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await getTherapistStats(debounceStartDate, debounceEndDate);
        if (response) {
          const totalStats = calculateTotalStats(response);
          const totalResults = calculateByLocationStats(response);
          const averageResults = calculateAverageStats(response);

          const therapistTable = mapTherapistTableData(response, totalResults, averageResults);
          const flattenTherapists = flattenTherapistStats(response);

          setTherapistData(therapistTable);
          setTherapistTotalsData(totalStats);
          setFlatTherapistData(flattenTherapists);
          
        }
      } catch (error) {
        // console.log("error", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [debounceStartDate, debounceEndDate]);

  return { therapistData, therapistTotalsData, flatTherapistData, isLoading };
};

export default useTherapistStats;